import template from './sw-cms-el-form-contact.html.twig';

// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default {
    template,
    props: ['formSettings'],
};
